<template>
	<div class="view-footer-root" :style="cssVars">
		<div class="top-line">

		</div>
		<div
			v-if="dataStore"
			class="sheet-view-group-add-button"
			:class="{
				disabled: !workbookHasPermission('sheet_addNew'),
			}"
			data-query-selector="add-new-view-button"
		>
			<r-tip-simple
				text="New View"
				position="right"
				:delay="0"
			>
				<r-standard-icon
					class="add-view-icon"
					icon="addPlus"
					color="grey-300"
					@click="addSheetView"
				/>
			</r-tip-simple>
		</div>
		<div class="sheet-view-group-folders">
			<sheet-view-group-tab
				v-for="(sheetViewGroup, sheetViewGroupIndex) in sortedSheetViewGroups"
				:key="sheetViewGroup.$internals.metaProperties.meta.guid"
				:sheetViewGroup="sheetViewGroup"
				:sheetViewGroupIndex="sheetViewGroupIndex"
				:selectedSheetViewGUID="selectedSheetViewGUID"
			>
			</sheet-view-group-tab>
		</div>
		<r-standard-dynamic-modal-filler
			v-if="addingSheetView"
			linkedModalName="global-level-0"
			:dynamicComponent="addSheetViewModal"
			:passedProps="{sortedSheetViewGroups, dataStore}"
			@closeModal="closeAddDupHelper"
		>
		</r-standard-dynamic-modal-filler>
		<r-standard-dynamic-modal-filler
			v-if="duplicatingSheetView"
			linkedModalName="global-level-0"
			:dynamicComponent="addSheetViewModal"
			:passedProps="duplicatingSheetView"
			@closeModal="closeAddDupHelper"
		>
		</r-standard-dynamic-modal-filler>
		<r-standard-dynamic-modal-filler
			v-if="renamingSheetView"
			linkedModalName="global-level-0"
			:dynamicComponent="editSheetViewNameModal"
			:passedProps="renamingSheetView"
			@closeModal="closeAddDupHelper"
		>
		</r-standard-dynamic-modal-filler>
		<r-standard-dynamic-modal-filler
			v-if="deletingSheetView"
			linkedModalName="global-level-0"
			:dynamicComponent="deleteSheetViewModal"
			:passedProps="deletingSheetView"
			@closeModal="deletingSheetView = false"
		>
		</r-standard-dynamic-modal-filler>
	</div>
</template>

<script type="text/javascript">

	import SheetViewGroupTab from 'vue/sheet-views/common/sheet-view-group-tab';
	import AddSheetViewModal from 'vue/sheet-views/common/add-sheet-view-modal';
	import EditSheetViewNameModal from 'vue/sheet-views/common/edit-sheet-view-name-modal';
	import DeleteSheetViewModal from 'vue/sheet-views/common/delete-sheet-view-modal';

	export default {
		name: 'view-footer-root',
		components:{
			SheetViewGroupTab,
		},
		$pubsub:{
			sheetViews:{
				subscriptions:{
					duplicateSheetView(params){
						this.duplicatingSheetView = Object.assign({}, params, {dataStore: this.dataStore});
					},
					createSheetView(params) {
						this.addSheetView();
					},
					renameSheetView(params){
						this.renamingSheetView = params;
					},
					deleteSheetView(params){
						this.deletingSheetView = params;
					},
				},
			}
		},
		inject:['workbookHasPermission'],
		props:{
			dataStore:{
				required: true,
			},
			selectedSheetViewGUID:{
				required: false,
			}
		},
		data(){
			return {
				addingSheetView: false,
				// for the rest of these, the value will be the prop passed to the modal filler
				// instead of just true or false
				duplicatingSheetView: false,
				renamingSheetView: false,
				deletingSheetView: false,
			}
		},
		computed:{
			sortedSheetViewGroups(){
				if(this.dataStore){
					return this.dataStore.sheetViewGroups.slice().sort(function compare(a, b){
						return a.sortOrder - b.sortOrder;
						// return a.$internals.metaProperties.meta.dateCreated - b.$internals.metaProperties.meta.dateCreated;
					});
				}
				return [];
			},
			addSheetViewModal(){
				return AddSheetViewModal;
			},
			duplicateSheetViewModal(){
				return DuplicateSheetViewModal;
			},
			editSheetViewNameModal(){
				return EditSheetViewNameModal;
			},
			deleteSheetViewModal(){
				return DeleteSheetViewModal;
			},
			cssVars(){
				let chatBubbleWidth = "150px";
				if (this.$root.systemState.experience === "desktop"){
					chatBubbleWidth = "0px"
				}

				return {
					"--chat-bubble-width": chatBubbleWidth
				}
			}
		},
		methods: {
			addSheetView() {
				const vcSelf = this;
				const lm = this.$root.systemState.licenseManager;
				lm.verifyProvisionedEntitlementAvailability("Workbook.Worksheets", 1, function withEntitlement(hasEntitlementAvailable) {
					if (hasEntitlementAvailable) {
						vcSelf.addingSheetView = true;
					} else {
						vcSelf.$pubsub.modules.upgrade.pub("openModal", {
							flowName: "entitlementExhausted",
							attributes: {
								entitlementIdentifier: "Workbook.Worksheets"
							}
						});
					}
				});
			},
			closeAddDupHelper(closeDetails){
				if(!closeDetails || closeDetails.source !== 'shroud'){
					this.addingSheetView = false;
					this.duplicatingSheetView = false;
					this.renamingSheetView = false
				}
			}
		},
	}
</script>


<style lang="scss" scoped>
	$chat-bubble-width: var(--chat-bubble-width);
	.view-footer-root{
		display: flex;
		flex-direction: row;
		overflow: hidden;
		max-width: 100%;
		box-sizing: border-box;
	}

	.top-line{
		background: #C3C9D4;
		height: 1px;
		width: 100%;
		position: absolute;
		top: 0;
	}


	.footer-gray-line{
		width: 40px;
	}

	.sheet-view-group-add-button{
		min-width: 55px;
		text-align: center;

		&.disabled{
			opacity: 0;
			pointer-events: none;
		}
	}

	.sheet-view-group-folders{
		@include flex(row, flex-start, flex-start);
		height: 71px; // This makes it so that height of the footer fills the entire container
		overflow-y: hidden;
		overflow-x: auto;
		width: calc(100% - #{$chat-bubble-width}); // This extra 150px is due to the chat bubble

		// all children that have a div before them get 15px left margin
		div + div {
			margin-left: 15px;
		}
	}

	.add-view-icon{
		margin-top: 9px;
		@include clickable;
	}

</style>